import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux';
import H3Public from '../../../text-components/H3Public'
import PPublic from '../../../text-components/PPublic'

const TermAndCondition = () => {

    const scrollPage = useRef();
    const theme = useSelector((state) => state.darkWhiteThemeToggle.theme);
    const scroll = useSelector((state) => state.scrollToTop.scroll);
  
    const scrollToTop = () => {
      scrollPage?.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  
    useEffect(() => {
      scrollToTop();
    }, [scroll]);

    return (
        <>
            <div className="about_page_main" ref={scrollPage}>

                <div className="about_page_content_main">

                    <div className="about_page_content_inner_main container-fluid" style={{ backgroundColor: `${theme === "WHITE" ? "#E1ECF3" : "#CBCBCB"}` }}>

                        <div className="about_page_content_heading" style={{ color: `${theme === "WHITE" ? "#394D61" : "#000"}` }} >
                            <h4>Term & Conditions</h4>
                        </div>

                        <div className="about_page_content_heading_line">
                            <div className="underline_thik" style={{ backgroundColor: `${theme === "WHITE" ? "#394D61" : "#858282"}` }}></div>
                            <div className="underline_thin"></div>
                        </div>

                        <div className="row about_page_content_box">

                            <div className="col p-0 content_main">
                                <div>
                                    <H3Public>Site Visit Data</H3Public>
                                    <PPublic>This website records your visit and logs the following information for statistical purposes your server's address; the name of the top-level domain from which you access the Internet (for example, .gov, .com, .in, etc.); the type of browser you use; the date and time you access the site; the pages you have accessed and the documents downloaded and the previous Internet address from which you linked directly to the site.
                                        We will not identify users or their browsing activities, except when a law enforcement agency may exercise a warrant to inspect the service provider's logs.</PPublic>
                                    <H3Public>Cookies</H3Public>
                                    <PPublic> A cookie is a piece of software code that an internet web site sends to your browser when you access information at that site.</PPublic>
                                    <H3Public>Email Management</H3Public>
                                    <PPublic> Your email address will only be recorded if you choose to send a message. It will only be used for the purpose for which you have provided it and will not be added to a mailing list. Your email address will not be used for any other purpose, and will not be disclosed, without your consent.</PPublic>
                                    <H3Public>Collection of Personal Information</H3Public>
                                    <PPublic> If you are asked for any other Personal Information you will be informed how it will be used if you choose to give it. If at any time you believe the principles referred to in this privacy statement have not been followed, or have any other comments on these principles, please notify the webmaster through the contact us page.</PPublic>
                                    <PPublic> <b>Note:</b> The use of the term "Personal Information" in this privacy statement refers to any information from which your identity is apparent or can be reasonably ascertained.</PPublic>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>


            </div>
        </>
    )
}

export default TermAndCondition